import React from 'react';
import { observer } from 'mobx-react';
import { Button } from '@this/shared/ui/inputs/button';
import { Input } from '@this/shared/ui/inputs/input';
import { FormControl, InputLabel } from '@this/shared/ui/inputs/form_control';
import type ForeignRegion from '@this/domain/god/foreign_region';

function getStyles() {
  return {
    buttonRow: {
      display: 'flex',
      gap: '10px',
      marginTop: '20px'
    } as React.CSSProperties,
    error: {
      color: '#dc3545',
      fontSize: '14px',
      marginTop: '10px'
    } as React.CSSProperties
  } as const;
}

interface ForeignRegionFormProps {
  foreignRegion: ForeignRegion;
  onSubmit: () => void;
  onCancel: () => void;
  error: string | null;
  submitLabel: string;
  cancelLabel: string;
}

const ForeignRegionForm: React.FC<ForeignRegionFormProps> = ({
  foreignRegion,
  onSubmit,
  onCancel,
  error,
  submitLabel,
  cancelLabel
}) => {
  const styles = getStyles();

  return (
    <div>
      <FormControl fullWidth style={{ marginBottom: '10px' }}>
        <InputLabel htmlFor="name">地域名 *</InputLabel>
        <Input
          id="name"
          value={foreignRegion.name || ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            foreignRegion.name = e.target.value;
          }}
        />
      </FormControl>
      <FormControl fullWidth style={{ marginBottom: '10px' }}>
        <InputLabel htmlFor="ministryOfForeignAffairsId">外務省ID</InputLabel>
        <Input
          id="ministryOfForeignAffairsId"
          value={foreignRegion.ministryOfForeignAffairsId || ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            foreignRegion.ministryOfForeignAffairsId = e.target.value || null;
          }}
        />
      </FormControl>
      {error && <div style={{ ...styles.error, whiteSpace: 'pre-wrap' }}>{error}</div>}
      <div style={styles.buttonRow}>
        <Button onClick={onSubmit}>{submitLabel}</Button>
        <Button color="sub" onClick={onCancel}>
          {cancelLabel}
        </Button>
      </div>
    </div>
  );
};

export default observer(ForeignRegionForm);
